import { useState } from "react";

type CaseImageProps = {
  src: string;
  alt: string;
  className?: string;
  /** O que mostrar se o arquivo não existir (em public/case-assets/). Sem fallback, a imagem some. */
  fallback?: React.ReactNode;
  loading?: "lazy" | "eager";
};

// Imagem que pode ainda não ter sido enviada: em vez do ícone de imagem quebrada, mostra o fallback.
export default function CaseImage({ src, alt, className, fallback = null, loading = "lazy" }: CaseImageProps) {
  const [failed, setFailed] = useState(false);
  if (failed) return <>{fallback}</>;
  return <img src={src} alt={alt} className={className} loading={loading} onError={() => setFailed(true)} />;
}
